module.exports = __webpack_public_path__ + "static/rsa-ce6a378ac1cb91537b07a4301fe06a72.jpg";